// 2021 Topps Star Wars Stellar Signatures
// Ultra-premium autograph box set — 100 boxes total, every signed card numbered.
// No base/insert sets. Structure source-verified against Cardboard Connection,
// BreakNinja and Hero Habit, plus eBay specimens (base auto 32/40, sketch
// reproduction /100, quad numbered). Card names seeded from the production DB
// (set_id 5841d860-be18-4cb6-a13f-1ab06d5e6c79).
//
// Rule-7 base serial slots: every auto base is numbered (/40, /25, /40) and the
// sketch reproductions are /100, so each sub-set carries a blank-name serial slot
// at the base print run (the DB had only the colored parallels, no base slot).
// Blank name → the UI renders just "/40", "/25", "/100" or "1/1".

const AUTO_PARALLELS_LADDER = [
  { id: 'base', name: '', print_run: 40, color: '#c8d8f0' },
  { id: 'blue', name: 'Blue Refractor', print_run: 25, color: '#4d9fff' },
  { id: 'green', name: 'Green Refractor', print_run: 20, color: '#00e87a' },
  { id: 'purple', name: 'Purple Refractor', print_run: 10, color: '#b060ff' },
  { id: 'gold', name: 'Gold Refractor', print_run: 5, color: '#f0c040' },
  { id: 'imperial-red', name: 'Imperial Red', print_run: 1, color: '#ff1744' },
  { id: 'galactic-black', name: 'Galactic Black', print_run: 1, color: '#b0b0b0' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 1, color: '#ff9100' },
];

const DUAL_PARALLELS = [
  { id: 'base', name: '', print_run: 25, color: '#c8d8f0' },
  { id: 'purple', name: 'Purple Refractor', print_run: 10, color: '#b060ff' },
  { id: 'gold', name: 'Gold Refractor', print_run: 5, color: '#f0c040' },
  { id: 'imperial-red', name: 'Imperial Red', print_run: 1, color: '#ff1744' },
  { id: 'galactic-black', name: 'Galactic Black', print_run: 1, color: '#b0b0b0' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 1, color: '#ff9100' },
];

const QUAD_PARALLELS = [
  { id: 'base', name: '', print_run: 40, color: '#c8d8f0' },
  { id: 'blue', name: 'Blue Refractor', print_run: 25, color: '#4d9fff' },
  { id: 'green', name: 'Green Refractor', print_run: 20, color: '#00e87a' },
  { id: 'cyan', name: 'Cyan', print_run: 15, color: '#00e5ff' },
  { id: 'purple', name: 'Purple Refractor', print_run: 10, color: '#b060ff' },
  { id: 'gold', name: 'Gold Refractor', print_run: 5, color: '#f0c040' },
  { id: 'galactic-black', name: 'Galactic Black', print_run: 1, color: '#b0b0b0' },
  { id: 'imperial-red', name: 'Imperial Red', print_run: 1, color: '#ff1744' },
  { id: 'rebel-orange', name: 'Rebel Orange Refractor', print_run: 1, color: '#ff9100' },
];

const REPRO_PARALLELS = [
  { id: 'serial', name: '', print_run: 100, color: '#c8d8f0' },
];

const ONE_OF_ONE = [
  { id: 'one-of-one', name: '', print_run: 1, color: '#f0c040' },
];

// The 100 sketch subjects/artists — shared by the standard-size Reproductions
// (/100) and the 5x7 Oversized originals (1/1). Fixes two DB typos: #40 R2-D2
// (DB "R2-DR"), #53 Kanan Jarrus (DB "Kanan Jarras").
const SKETCH_SUBJECTS = [
  {n:'1', name:'Kuiil', artist:'Dan Bergren'},
  {n:'2', name:'Hunter', artist:'Carlos Cabaleiro'},
  {n:'3', name:'Omega', artist:'Candice Dailey'},
  {n:'4', name:'Baze Malbus', artist:'Jason Davies'},
  {n:'5', name:'Ben Solo', artist:'Dan Tearle'},
  {n:'6', name:'Han Solo', artist:'Dan Bergren'},
  {n:'7', name:'Wrecker', artist:'Carlos Cabaleiro'},
  {n:'8', name:'Caleb Dume', artist:'Candice Dailey'},
  {n:'9', name:'Bodhi Rook', artist:'Jason Davies'},
  {n:'10', name:'Flame Trooper', artist:'Dan Tearle'},
  {n:'11', name:"Qi'ra", artist:'Dan Bergren'},
  {n:'12', name:'Tech', artist:'Carlos Cabaleiro'},
  {n:'13', name:'Wilhuff Tarkin', artist:'Candice Dailey'},
  {n:'14', name:'Captain Cassian Andor', artist:'Jason Davies'},
  {n:'15', name:"Rey's Speeder", artist:'Dan Tearle'},
  {n:'16', name:'Tobias Beckett', artist:'Dan Bergren'},
  {n:'17', name:'Crosshair', artist:'Carlos Cabaleiro'},
  {n:'18', name:'Saw Gerrera', artist:'Candice Dailey'},
  {n:'19', name:'Chirrut Îmwe', artist:'Jason Davies'},
  {n:'20', name:'Supreme Leader Snoke', artist:'Dan Tearle'},
  {n:'21', name:'Poe Dameron', artist:'Dan Bergren'},
  {n:'22', name:'Echo', artist:'Carlos Cabaleiro'},
  {n:'23', name:'Dark Trooper', artist:'Dan Tearle'},
  {n:'24', name:'Galen Erso', artist:'Jason Davies'},
  {n:'25', name:'BB-8', artist:'Dan Tearle'},
  {n:'26', name:'Finn', artist:'Dan Bergren'},
  {n:'27', name:'Cad Bane', artist:'Carlos Cabaleiro'},
  {n:'28', name:'General Leia Organa', artist:'Candice Dailey'},
  {n:'29', name:'Jyn Erso', artist:'Jason Davies'},
  {n:'30', name:'AT-ST Walker', artist:'Dan Tearle'},
  {n:'31', name:'Obi-Wan Kenobi', artist:'Dan Bergren'},
  {n:'32', name:'Captain Rex', artist:'Carlos Cabaleiro'},
  {n:'33', name:'Rose Tico', artist:'Candice Dailey'},
  {n:'34', name:'K-2SO', artist:'Jason Davies'},
  {n:'35', name:'C-3PO', artist:'Dan Tearle'},
  {n:'36', name:'Jango Fett', artist:'Dan Bergren'},
  {n:'37', name:'Jesse', artist:'Carlos Cabaleiro'},
  {n:'38', name:'Padmé Amidala', artist:'Candice Dailey'},
  {n:'39', name:'Jabba the Hutt', artist:'Jason Davies'},
  {n:'40', name:'R2-D2', artist:'Dan Tearle'},
  {n:'41', name:'Anakin Skywalker', artist:'Dan Bergren'},
  {n:'42', name:'Cobb Vanth', artist:'Candice Dailey'},
  {n:'43', name:'Zam Wesell', artist:'Candice Dailey'},
  {n:'44', name:'Greedo', artist:'Jason Davies'},
  {n:'45', name:'Darth Vader', artist:'Dan Tearle'},
  {n:'46', name:'Qui-Gon Jinn', artist:'Dan Bergren'},
  {n:'47', name:'Ahsoka Tano', artist:'Carlos Cabaleiro'},
  {n:'48', name:'Hera Syndulla', artist:'Candice Dailey'},
  {n:'49', name:'Saw Gerrera', artist:'Jason Davies'},
  {n:'50', name:'Han Solo', artist:'Dan Tearle'},
  {n:'51', name:'Lando Calrissian', artist:'Dan Bergren'},
  {n:'52', name:'Captain Phasma', artist:'Carlos Cabaleiro'},
  {n:'53', name:'Kanan Jarrus', artist:'Candice Dailey'},
  {n:'54', name:'Zorii Bliss', artist:'Jason Davies'},
  {n:'55', name:'Scout Trooper', artist:'Dan Tearle'},
  {n:'56', name:'Ben Kenobi', artist:'Dan Bergren'},
  {n:'57', name:'Nien Nunb', artist:'Carlos Cabaleiro'},
  {n:'58', name:'The Grand Inquisitor', artist:'Candice Dailey'},
  {n:'59', name:'Chewbacca', artist:'Jason Davies'},
  {n:'60', name:'Snow Trooper', artist:'Dan Tearle'},
  {n:'61', name:'Yoda', artist:'Dan Bergren'},
  {n:'62', name:'Luke Skywalker', artist:'Carlos Cabaleiro'},
  {n:'63', name:'Zeb Orrelios', artist:'Candice Dailey'},
  {n:'64', name:'Darth Maul', artist:'Jason Davies'},
  {n:'65', name:'AT-AT Walkers', artist:'Dan Tearle'},
  {n:'66', name:'Princess Leia', artist:'Dan Bergren'},
  {n:'67', name:'Ezra Bridger', artist:'Carlos Cabaleiro'},
  {n:'68', name:'The Mandalorian', artist:'Candice Dailey'},
  {n:'69', name:'Darth Sidious', artist:'Jason Davies'},
  {n:'70', name:'The Armorer', artist:'Dan Tearle'},
  {n:'71', name:'Wicket W. Warrick', artist:'Dan Bergren'},
  {n:'72', name:'Grand Admiral Thrawn', artist:'Carlos Cabaleiro'},
  {n:'73', name:'Greef Karga', artist:'Candice Dailey'},
  {n:'74', name:'General Grievous', artist:'Jason Davies'},
  {n:'75', name:'TIE Fighter', artist:'Dan Tearle'},
  {n:'76', name:'Wedge Antilles', artist:'Dan Bergren'},
  {n:'77', name:'Emperor Palpatine', artist:'Carlos Cabaleiro'},
  {n:'78', name:'The Client', artist:'Candice Dailey'},
  {n:'79', name:'Jar Jar Binks', artist:'Jason Davies'},
  {n:'80', name:'X-Wing Fighter', artist:'Dan Tearle'},
  {n:'81', name:'Maz Kanata', artist:'Dan Bergren'},
  {n:'82', name:'Rey', artist:'Carlos Cabaleiro'},
  {n:'83', name:'Moff Gideon', artist:'Candice Dailey'},
  {n:'84', name:'Mace Windu', artist:'Jason Davies'},
  {n:'85', name:"Boba Fett's Ship", artist:'Dan Tearle'},
  {n:'86', name:'Snap Wexley', artist:'Dan Bergren'},
  {n:'87', name:'Jawa', artist:'Carlos Cabaleiro'},
  {n:'88', name:'Bo-Katan Kryze', artist:'Candice Dailey'},
  {n:'89', name:'Queen Amidala', artist:'Jason Davies'},
  {n:'90', name:'Imperial Star Destroyer', artist:'Dan Tearle'},
  {n:'91', name:'Grogu', artist:'Dan Bergren'},
  {n:'92', name:'Ahsoka Tano', artist:'Candice Dailey'},
  {n:'93', name:'Frog Lady', artist:'Candice Dailey'},
  {n:'94', name:'Admiral Ackbar', artist:'Jason Davies'},
  {n:'95', name:'The Razor Crest', artist:'Dan Tearle'},
  {n:'96', name:'Kylo Ren', artist:'Dan Bergren'},
  {n:'97', name:'Boba Fett', artist:'Carlos Cabaleiro'},
  {n:'98', name:'Fennec Shand', artist:'Candice Dailey'},
  {n:'99', name:'Boba Fett', artist:'Jason Davies'},
  {n:'100', name:'Imperial Guard', artist:'Dan Tearle'},
];

export const SETS = [
  {
    id: 'sketch-card-reproductions', type: 'sketch', title: 'SKETCH CARD REPRODUCTIONS — 100 CARDS (/100)', parallels: REPRO_PARALLELS,
    cards: SKETCH_SUBJECTS,
  },
  {
    id: 'oversized-sketch-cards', type: 'sketch', title: 'OVERSIZED SKETCH CARDS — 100 CARDS (1/1)', parallels: ONE_OF_ONE,
    cards: SKETCH_SUBJECTS,
  },
  {
    id: 'on-card-autographs', type: 'auto', title: 'ON-CARD AUTOGRAPHS — 36 CARDS', parallels: AUTO_PARALLELS_LADDER,
    cards: [
      {n:'A-AB', name:'Ahmed Best'},
      {n:'A-AD', name:'Adam Driver'},
      {n:'A-AE', name:'Ashley Eckstein'},
      {n:'A-AS', name:'Andy Serkis'},
      {n:'A-ASP', name:'Amy Sedaris'},
      {n:'A-BDW', name:'Billy Dee Williams'},
      {n:'A-BL', name:'Billie Lourd'},
      {n:'A-CB', name:'Caroline Blakiston'},
      {n:'A-CH', name:'Clint Howard'},
      {n:'A-CW', name:'Carl Weathers'},
      {n:'A-DLI', name:'Diana Lee Inosanto'},
      {n:'A-DR', name:'Daisy Ridley'},
      {n:'A-EC', name:'Emilia Clarke'},
      {n:'A-EK', name:'Erin Kellyman'},
      {n:'A-ES', name:'Emily Swallow'},
      {n:'A-FJ', name:'Felicity Jones'},
      {n:'A-GE', name:'Giancarlo Esposito'},
      {n:'A-HC', name:'Hayden Christensen'},
      {n:'A-HF', name:'Harrison Ford'},
      {n:'A-HQ', name:'Hugh Quarshie'},
      {n:'A-JAT', name:'James Arnold Taylor'},
      {n:'A-KB', name:'Kenny Baker'},
      {n:'A-KMT', name:'Kelly Marie Tran'},
      {n:'A-LM', name:'Lars Mikkelsen'},
      {n:'A-ML', name:'Matt Lanter'},
      {n:'A-MP', name:'Michael Pennington'},
      {n:'A-MV', name:'Mercedes Varnado'},
      {n:'A-MW', name:'Matthew Wood'},
      {n:'A-NA', name:'Naomi Ackie'},
      {n:'A-NP', name:'Natalie Portman'},
      {n:'A-OA', name:'Omid Abtahi'},
      {n:'A-RD', name:'Rosario Dawson'},
      {n:'A-SK', name:'Simon Kassianides'},
      {n:'A-TG', name:'Taylor Gray'},
      {n:'A-TW', name:'Taika Waititi'},
      {n:'A-WD', name:'Warwick Davis'},
    ]
  },
  {
    id: 'on-card-dual-autographs', type: 'auto', title: 'ON-CARD DUAL AUTOGRAPHS — 8 CARDS', parallels: DUAL_PARALLELS,
    cards: [
      {n:'DA-BG', name:'Taylor Gray / Dee Bradley Baker'},
      {n:'DA-DD', name:'Harrison Davis / Warwick Davis'},
      {n:'DA-EB', name:'Dee Bradley Baker / Ashley Eckstein'},
      {n:'DA-FD', name:'Adam Driver / Harrison Ford'},
      {n:'DA-LE', name:'Matt Lanter / Ashley Eckstein'},
      {n:'DA-RD', name:'Daisy Ridley / Adam Driver'},
      {n:'DA-RW', name:'Billy Dee Williams / Daisy Ridley'},
      {n:'DA-VK', name:'Simon Kassianides / Mercedes Varnado'},
    ]
  },
  {
    id: 'on-card-quad-autographs', type: 'auto', title: 'ON-CARD QUAD AUTOGRAPH — 1 CARD', parallels: QUAD_PARALLELS,
    cards: [
      {n:'QD-CW', name:'Dee Bradley Baker / Matt Lanter / James Arnold Taylor / Ashley Eckstein'},
    ]
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

export const PARALLELS = REPRO_PARALLELS;
export const AUTO_PARALLELS = AUTO_PARALLELS_LADDER;
export const INSERT_PARALLELS = [];
